import ParentHouseholdProfile from "@/pages/ParentHouseholdProfile"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/household")({
  component: ParentHouseholdProfile,
})
